import imageCompression from "browser-image-compression";

export const lineText = (text) => {
  const newText = text
    ?.split("\n")
    ?.map((str) => <p style={{ margin: 0 }}>{str}</p>);
  return newText;
};

export const listTolineText = (list) => {
  const newText = list?.map((text) =>
    text?.split("\n")?.map((str) => <p style={{ margin: 0 }}>{str}</p>)
  );
  return newText;
};

export const findKeyByValue = (obj, targetValue) => {
  for (let key in obj) {
    if (obj[key] === targetValue) {
      return key;
    }
  }
  return null;
};

export const closedTab = (url) => {
  window.open(`${url ?? "about:blank"}`, "_self");
  window.history?.deleteAll();
};

export const compressImageFile = async (file) => {
  const options = {
    maxSizeMB: 2,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };

  const compressedFile = await imageCompression(file, options);
  return compressedFile;
};

